import {z} from 'zod'

export const unitOnRentRawSchema = z.object({
    rental_asset_id: z.string(),
    order: z.string(),
    label: z.string(),
})

export type UnitOnRentRaw = z.infer<typeof unitOnRentRawSchema>

export const unitOnRentSchema = unitOnRentRawSchema.transform((raw) => ({
    rentalAssetId: raw.rental_asset_id,
    order: raw.order,
    label: raw.label,
}))

export type UnitOnRent = z.infer<typeof unitOnRentSchema>
